import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';
import { formulaSetVersionNoScriptDto } from './formula-set-version.dto';

export const formulaSetDto = z.object({
  id: z.string(),
  note: z.string().nullable(),
});

export const formulaSetListDto = z.object({
  list: formulaSetDto.array(),
});

export const formulaSetDetailedDto = formulaSetDto.extend({
  versions: formulaSetVersionNoScriptDto.array(),
});

export class FormulaSetDto extends createZodDto(formulaSetDto) {}

export class FormulaSetListDto extends createZodDto(formulaSetListDto) {}

export class FormulaSetDetailedDto extends createZodDto(
  formulaSetDetailedDto,
) {}
